import { render, staticRenderFns } from "./GlobalView.vue?vue&type=template&id=2ccd181a&scoped=true"
import script from "./GlobalView.vue?vue&type=script&lang=js"
export * from "./GlobalView.vue?vue&type=script&lang=js"
import style0 from "./GlobalView.vue?vue&type=style&index=0&id=2ccd181a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd181a",
  null
  
)

export default component.exports